import React from 'react';
import './Weed.css';
import weedImage from '../assets/images/weed.png';

function Weed() {
  return (
    <div className="weed-container">
      <img src={weedImage} alt="Weed" className="weed-image" />
    </div>
  );
}

export default Weed;
